import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CertificateImage from "../../../../components/Certificate/CertificateImage";
import { useDispatch, useSelector } from "react-redux";
import { editCertificate, getCertificateById } from "../../../../redux/features/certificate/certificateService";
import NoResultsFound from "../../../../components/NoResultsFound";
import GridLoader from "react-spinners/GridLoader";

const PreviewCertificate = () => {
    const { certificate_id } = useParams();
    const dispatch = useDispatch();

    const { isLoadingCertificateDetails, isCertificateDetailsSuccess, certificate } = useSelector((state) => state.certificate.certificateDetails);

    const [certificateImage, setCertificateImage] = useState(null);
    useEffect(() => {
        dispatch(getCertificateById({ certificate_id })).unwrap();
    }, [dispatch, certificate_id]);

    return (
        <div className={`main-card`}>
            {isLoadingCertificateDetails ? (
                <div className={`loader-style`}>
                    <GridLoader color="#df771c" />
                </div>
            ) : !isCertificateDetailsSuccess ? (
                <NoResultsFound />
            ) : (
                <>
                    <CertificateImage data={certificate} onImageGenerated={setCertificateImage} />
                    {certificateImage !== null ? (
                        <div>
                            <div className={`form-input-row`}>Certificate Preview                              
                            </div>
                            <img src={certificateImage} alt="Certificate Preview" style={{ width: "100%", maxWidth: "400px", border: "1px solid #ccc" }} />
                        </div>
                    ) : <div className={`loader-style`}>
                        <GridLoader color="#df771c" />
                    </div>}
                </>
            )}          
        </div>
    );
};
export default PreviewCertificate;
